<div class="loading-indicator" *ngIf="isLoading">
  <mat-progress-spinner mode="indeterminate" color="accent"></mat-progress-spinner>
</div>
<div fxLayoutAlign="center" style="margin-top: 20px;">
  <h1>Registry Download</h1>
</div>
<div class="d-flex">
  <div class="col-2"></div>
  <div class="col-8">
    <div class="row">
      <div>
        <form class="signature-tab-form" [formGroup]="form">
          <mat-tab-group [selectedIndex]="selectedIndex" #tabs (selectedTabChange)="tabChanged($event)" mat-align-tabs="center">
            <mat-tab label="Registry Download">
              <div fxLayout="row" class="address-width mt-3">
                <div class="col-4">
                  <mat-label class="boldlabel">Select database option for download</mat-label>
                </div>
                <div class="col-6">
                  <div fxLayout="row">
                    <mat-checkbox [checked]="sendToMode === 1" (change)="onCheck(1, $event)">Full Registry Download file
                    </mat-checkbox>
                  </div>
                  <div fxLayout="row">
                    <p style="font-style: italic; margin-left: 30px;margin-top: -15px;">Cost is $1000.00 plus any
                      applicable service fee
                    </p>
                  </div>

                  <div fxLayout="row">
                    <mat-checkbox [checked]="sendToMode === 2" (change)="onCheck(2, $event)">Prior Month's Registry
                      Activity file </mat-checkbox>
                  </div>
                  <div fxLayout="row">
                    <p style="font-style: italic; margin-left: 30px;margin-top: -15px;">Cost is $50.00 plus any
                      applicable service fee
                    </p>
                  </div>

                  <div fxLayout="row">
                    <mat-checkbox [checked]="sendToMode === 3" (change)="onCheck(3, $event)">Prior Week's Registry
                      Activity </mat-checkbox>
                  </div>
                  <div fxLayout="row">
                    <p style="font-style: italic; margin-left: 30px;margin-top: -15px;">Cost is $50.00 plus any
                      applicable service fee
                    </p>
                  </div>
                  <div fxLayout="row">
                    <div class="error" *ngIf="isError">At least one checkbox is required to check</div>
                  </div>
                </div>
              </div>
              <div  fxLayout="row" fxLayoutAlign="center">
                <mat-label class="boldlabel">The download includes Workers' Compensation Exemption Registry Records.</mat-label>
              </div>
              <div  fxLayout="row" fxLayoutAlign="center">
                <mat-label class="boldlabel">The download file is a zip compressed file containing tab separated text files, each representing a
                  relational data table.</mat-label>
              </div>
              <div fxLayout="row" fxLayoutAlign="center center" class="mt-3">
                <mat-label class="boldlabel">A schema diagram is included and can be viewed free of charge:
                </mat-label>
                <button mat-raised-button color="primary" style="margin-left: 15px;"
                  (click)="viewSample()">View</button>
              </div>
            </mat-tab>
            <mat-tab label="Signature">

              <div class="normalFont">{{signatureText}}</div>
              <div class="italicFont">{{agreeText}}</div>
              <div fxLayout="row" fxLayoutGap="50px">
                <mat-form-field class="first-name-width">
                  <mat-label class="boldlabel">First Name</mat-label>
                  <input matInput placeholder="First Name" formControlName="signatureFirstName" value="">
                </mat-form-field>
                <mat-form-field class="middle-width">
                  <mat-label>Middle Initial</mat-label>
                  <input matInput placeholder="Middle Initial" formControlName="signatureMiddleName" value="">
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutGap="50px">
                <mat-form-field class="first-name-width">
                  <mat-label class="boldlabel">Last Name</mat-label>
                  <input matInput placeholder="Last Name" formControlName="signatureLastName" value="">
                </mat-form-field>
                <mat-form-field class="middle-width">
                  <mat-label>Suffix</mat-label>
                  <input matInput placeholder="Suffix" formControlName="signatureSuffix" value="">
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayoutGap="50px">
                <mat-form-field class="title-width">
                  <mat-label class="">Title</mat-label>
                  <input matInput placeholder="Title" formControlName="signatureTitle" value="">
                </mat-form-field>
                <mat-checkbox [ngClass]="form.controls['signatureICertify'].invalid ? 'errorMsg' : ''"
                  class="mailingAddress boldlabel" formControlName="signatureICertify">I Certify</mat-checkbox>
              </div>
              <div class="italicFont"></div>

              <!-- Suffix -->
            </mat-tab>
            <mat-tab label="Payment">

              <div fxLayoutAlign="center" style="margin-top: 20px;">
                <h4>Please select Pay Online
                </h4>
              </div>
              <div fxLayoutAlign="center">
                <h4 style="font-style: italic; margin-top: -15px;">You will be re-directed to our Payment Portal
                </h4>
              </div>
              <div fxLayoutAlign="center">
                <h4 style="color: black;font-weight:bold">{{downloadType}} </h4>
                <h4 style="color: black;font-weight:bold;margin-left: 5px;">${{amount}}
                </h4>
              </div>
              <div class="row" style="margin-top: 20px;">
                <div fxLayoutAlign="center center">
                  <button [disabled]="fiscompleted" (click)="onOnlinePayment()" mat-raised-button color="primary"
                    style="min-width: 150px">Pay
                    Online</button>
                <!-- </div> -->
                <!-- <div class="col-8"> -->
                  <h4 style="color: black;font-weight:bold;margin-left: 10px;">Pay Online by Credit Card or e-Check</h4>
                </div>
              </div>
              <div *ngIf="!this.isLoading && candownload" fxLayoutAlign="center">
                <h1 style="color: green">Payment Successful - Registry Download is available.</h1>
              </div>
              <div *ngIf="!this.isLoading && candownload" fxLayoutAlign="center">
                <h1 style="color: green">Please click Download button.</h1>
              </div>
            </mat-tab>
          </mat-tab-group>
        </form>
      </div>
    </div>
    <div style="margin-top: 20px;margin-bottom: 130px;">
      <div class="row">
        <div class="col-4">
          <button *ngIf="selectedIndex > 0 && selectedIndex < 2" mat-raised-button
            style="margin-left: '30px'; border-radius: 5px; background-color: '#e7e3e3'; color: 'black';"
            (click)="previousStep()">Back</button>
        </div>
        <div *ngIf="selectedIndex < 2" class="col-4">
          <div><button [disabled]="isLoading" mat-raised-button color="primary"
              (click)="saveAndContinue()">Continue</button></div>
        </div>
        <div *ngIf="selectedIndex < 2" class="col-4" fxFlex fxLayoutAlign="end start">
          <button mat-raised-button
            style="border-radius: 5px; background-color: '#e7e3e3'; color: 'black'; margin-right: 100px;"
            (click)="onCancel()">Cancel</button>
        </div>

      </div>
      <div *ngIf="selectedIndex == 2" fxLayoutAlign="center" class="mt-1">
        <div><button *ngIf="!this.isLoading && candownload" mat-raised-button color="primary"
            (click)="download()">Download</button></div>
      </div>
      <div *ngIf="selectedIndex == 2" fxLayoutAlign="center" class="mt-2">
        <div><button mat-raised-button color="primary" (click)="close()">Close</button></div>
      </div>
    </div>
  </div>
</div>
